import { Epic, ofType } from 'redux-observable';
import { concat, EMPTY, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { Action } from '../../actions';
import {
    SAVE_IMPORT_EXPORT_WIZARD,
    SaveImportExportWizard
} from '../../actions/importExportWizard/saveImportExportWizard';
import {
    UpdateImportExportWizardLock,
    updateImportExportWizardLockAction
} from '../../actions/importExportWizard/updateImportExportWizardLock';
import { SaveImportWizard, saveImportWizardAction } from '../../actions/importWizard/saveImportWizard';
import { EpicDeps } from '../../service/StoreFactory';
import { ImportExportWizardMode } from '../../typings/importExportWizard';
import { State } from '../../typings/state';

type EpicActions = SaveImportWizard | UpdateImportExportWizardLock;

export const saveImportExportWizardEpic: Epic<Action, Action, State, EpicDeps> = (action$, store) => {
    return action$.pipe(
        ofType(SAVE_IMPORT_EXPORT_WIZARD),
        switchMap(
            (action: SaveImportExportWizard): Observable<EpicActions> => {
                const state = store.value;

                switch (state.importExportWizard.wizardMode) {
                    case ImportExportWizardMode.IMPORT:
                        return concat(of(updateImportExportWizardLockAction(true)), of(saveImportWizardAction()));
                    case ImportExportWizardMode.EXPORT:
                        return EMPTY;
                    default:
                        return EMPTY;
                }
            }
        )
    );
};
